import { AllCompetitionsPage } from './AllCompetitionsPage'
export { AllCompetitionsPage }
export default AllCompetitionsPage
import { AllCompetitionsPage } from './AllCompetitionsPage'
export { AllCompetitionsPage }
export default AllCompetitionsPage
